export default __webpack_public_path__ + "static/media/logo_en.c52834f9.png";